import HttpService from "./htttp.service";

class LeasesService {
    getList = async(payload) => {
        const token = localStorage.getItem("token");
        const getListEndPoint = "leases"
        return await HttpService.get(getListEndPoint, payload, token);
    }
    updateLease = async(payload) => {
        const token = localStorage.getItem("");
        const updateLeaseEndPoint = "leases-v2/" + payload.lease_id;
        return await HttpService.post(updateLeaseEndPoint, payload, token, false);
    }
    searchCode = async(payload) => {
        const token = localStorage.getItem("token");
        const searchCodeEndPoint = "tenants/search_code"; // https://mgt.yeelim.org/backend/api/v1/tenants/search_code
        return await HttpService.post(searchCodeEndPoint, payload, token);
    }
}

export default new LeasesService();
